type Props = {
    className?: any,
    type: any,
    name?: any,
    onChange?: any,
    placeHolder?: any,
    value?: any,
    disabled?: boolean,
    maxLength?: any,
    id?: string;
    checked?: any,
    min?: any,
    max?: any,
    onClick?: any,
    onBlur?: any,
    ref?: any,
    defaultValue?: any,
    pattern?: any,
    minLength ? : any,
    onLeave?: any,
    title?:any;
    webkitdirectory?:any,
    directory?:any,
    onKeyPress?:any,
    readOnly?: any
};

function WMSInput(props: Props){
    let { className, type, placeHolder,id, disabled, value, onChange,maxLength, minLength,defaultValue, pattern,onLeave, title,readOnly, onKeyPress, ...restProps } = props;
    return(
        <>
            <input autoComplete="off" className={className} type={type} placeholder={placeHolder} disabled={disabled} title={title} id={id}
            maxLength={maxLength} minLength ={minLength} value={value} onChange={(e) => onChange(e)}  onMouseLeave={onLeave} defaultValue={defaultValue} readOnly={readOnly}
            onKeyPress={onKeyPress} pattern={pattern} {...restProps}/>
        </>
    )
}
export {
    WMSInput
};